// Heurística compartida para detectar si una empresa es un restaurante/bar/negocio
// de comida, a partir del nombre de su categoría. Usada para mostrar funciones
// específicas (comanda, mesas) solo donde tienen sentido.
export const FOOD_KEYWORDS = [
  "restaurante", "restaurant", "comida", "food", "cocina", "pizza", "burger",
  "hamburgues", "sushi", "pollo", "desayuno", "almuerzo", "cena",
  "bebida", "café", "cafe", "cafetería", "panadería", "panaderia", "bakery",
  "postres", "helados", "heladería", "mariscos", "pescado", "pastas",
  "tacos", "empanada", "fritanga", "asadero",
];

export function isFoodCategory(category) {
  if (!category) return true; // si no hay categoría, mostrar igual
  const name = (category.name || "").toLowerCase();
  return FOOD_KEYWORDS.some((k) => name.includes(k));
}
